import React, {useState} from 'react'
import styled from '@emotion/styled'

const GoodReviewRoot = styled.div`
  padding: 15px 0;
  border-top: 1px solid #ddd;
  font-size: 13px;
  
  &:last-child {
    border-bottom: 1px solid #ddd;
  }
`

const ReviewTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
`

const ReviewContent = styled.div``

const CreatedAt = styled.div`
  flex-shrink: 0;
`

const Text = styled.span`
  margin-right: 5px;
`

const Action = styled.span`
  display: inline-block;
  cursor: pointer;
  color: #2d9831;
  font-weight: 600;
  font-size: 12px;
  text-decoration: none;
  border-bottom: 1px solid #c1dec2;
`

const GoodReview = ({
  compact,
  id,
  authorName,
  createdAt,
  text,
  trimmedText,
}) => {
  const longerTextExists = text.length > trimmedText.length && trimmedText.slice(-3) === '...'
  const [showFullText, setShowFullText] = useState(false)
  return <GoodReviewRoot>
    <ReviewTitle>
      <div>{authorName}</div>
      <CreatedAt>{createdAt}</CreatedAt>
    </ReviewTitle>
    <ReviewContent>
      <Text>{compact && !showFullText ? trimmedText : text}</Text>
      {compact && longerTextExists && !showFullText && <Action onClick={() => setShowFullText(true)}>Развернуть целиком</Action>}
      {compact && longerTextExists && showFullText && <Action onClick={() => setShowFullText(false)}>Свернуть</Action>}
    </ReviewContent>
  </GoodReviewRoot>
}

export default GoodReview
